import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalSubject = new Subject<string>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private activeModals = new Map<string, any>(); // Mappa per tenere traccia delle modali attive

  modalState$ = this.modalSubject.asObservable();

  openModal(modalName: string): void {
    console.log('Opening modal:', modalName);
    this.modalSubject.next(modalName);


    if (this.activeModals.has(modalName)) {
      this.closeModal(modalName);
    }

    // Chiude altre modali attive
    this.closeAllModals();

    setTimeout(() => {
      const modalElement = document.getElementById(modalName);
      if (modalElement) {
        const modalInstance = new window.bootstrap.Modal(modalElement, {
          backdrop: 'static',
          keyboard: false
        });
        modalInstance.show();
        this.activeModals.set(modalName, modalInstance);

        // Gestione pulizia automatica
        modalElement.addEventListener('hidden.bs.modal', () => {
          this.cleanupModal(modalName);
        });
      } else {
        console.error('Modal element not found for:', modalName);
      }
    }, 100);
  }

  closeModal(modalName: string): void {
    if (this.activeModals.has(modalName)) {
      const modalInstance = this.activeModals.get(modalName);
      modalInstance.hide();
      document.body.style.overflow = '';
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      this.cleanupModal(modalName);
    }
  }

  closeAllModals(): void {
    this.activeModals.forEach((instance, name) => {
      instance.hide();
      this.cleanupModal(name);
    });
  }

  private cleanupModal(modalName: string): void {
    if (this.activeModals.has(modalName)) {
      const modalInstance = this.activeModals.get(modalName);
      modalInstance.dispose();
      this.activeModals.delete(modalName);

      const modalElement = document.getElementById(modalName);
      if (modalElement) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        modalElement.removeEventListener('hidden.bs.modal', () => { });
      }
    }
  }
}
